import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function CreateNewAssetSubmissionService(data,token) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/createNewAssetSubmission`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        notify.NotifySuccess("Assets submitted successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while changing Asset Status, please try again later.");
        return false;
    });
}

export default CreateNewAssetSubmissionService;